import { RestaurantState } from 'types/app/restaurant';

export const restaurantInitialState: RestaurantState = {
  id: 0,
  info: {},
  address: {},
  social_media: {},
};
